import React from 'react';

import setActiveTopMenuDropdownOperation from 'editor/src/store/app/operation/setActiveTopMenuDropdownOperation';
import isTopMenuDropdownVisible from 'editor/src/store/app/selector/isTopMenuDropdownVisible';
import { TopMenuDropdown } from 'editor/src/store/app/types';
import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import setSidebarActiveTabOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabOperation';
import isSidebarTabActive from 'editor/src/store/editorModules/sidebar/selector/isSidebarTabActive';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import IconOpacity from 'editor/src/component/Icon/IconOpacity';
import { MenuItemProps } from 'editor/src/component/Menu/type';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

type Props = Pick<MenuItemProps, 'mode' | 'close' | 'isMobile'>;

function ButtonImageOpacity({ mode, close, isMobile }: Props) {
  const isActive = useSelector((state) =>
    isMobile
      ? isSidebarTabActive(state, TAB_NAMES.IMAGE_OPACITY)
      : isTopMenuDropdownVisible(state, TopMenuDropdown.ImageOpacity),
  );
  const dispatch = useDispatch();

  const handleClick = () => {
    if (isMobile) {
      dispatch(
        isActive ? setSidebarActiveTabOperation(-1) : setSidebarActiveTabByNameOperation(TAB_NAMES.IMAGE_OPACITY),
      );
    } else {
      dispatch(setActiveTopMenuDropdownOperation(TopMenuDropdown.ImageOpacity));
      close?.();
    }
  };

  return (
    <MenuButton
      Icon={IconOpacity}
      on={isActive}
      mode={mode}
      handleClick={handleClick}
      i18nKey="editor-opacity"
      className="cy-button-image-opacity"
    />
  );
}

export default React.memo(ButtonImageOpacity);
